<template>
  <BCard>
    <BTable ref="refExpenseListTable" :items="fetchExpenses" responsive :fields="tableColumns" primary-key="id" :sort-by.sync="sortBy" show-empty :empty-text="$t('No matching records found')" :sort-desc.sync="isSortDirDesc" class="position-relative">

    <!-- Column: Id -->
    <template #cell(id)="data">
      <BLink :to="{ name: 'expenses-view', params: { id: data.item.id }}" class="font-weight-bold">
        <span class="text-nowrap"> {{data.item.name }}</span>
      </BLink>
      <br>
      <small><span><b>{{ data.item.n_expense ? 'Factura' : 'Recibo' }}</b></span></small>
    </template>

    <template #head(paid)>
      <feather-icon icon="TrendingUpIcon" class="mx-auto" />
    </template>

    <!-- Column: Expense Status -->
    <template #cell(paid)="data">
      <div>
        <BAvatar :id="`expense-row-${data.item.id}`" size="32" :variant="`light-${resolveExpenseStatusVariantAndIcon(data.item.amount, data.item.total_payments).variant}`" >
          <FeatherIcon :icon="resolveExpenseStatusVariantAndIcon(data.item.amount, data.item.total_payments).icon" />
        </BAvatar>
        <span>{{ resolveExpenseStatusVariantAndIcon(data.item.amount, data.item.total_payments).label }}</span>
      </div>
    </template>

    <template #cell(amount)="data">
      <div class="text-center">
        <span><b>{{formatCurrency(data.item.amount)}}</b></span>
        <div class="text-center">
          <BBadge  pill variant="light-warning" v-if="isPartialPaid(data.item.amount, data.item.total_payments).value">{{ (isPartialPaid(data.item.amount, data.item.total_payments).owe).toFixed(2) }}€ pendientes</BBadge>
        </div>
      </div>
    </template>

    <!-- Column: Issued Date -->
    <template #cell(dates)="data">
      <small>
        <span class="text-nowrap"><b>Emisión: </b>{{ formatDate(data.item.emit_date) }}</span><br>
        <span class="text-nowrap"><b>Vencimiento: </b>{{ data.item.payment_date ? formatDate(data.item.payment_date) : '(No definida)' }}</span>
      </small>
    </template>

    <template #cell(payment_method)="data">
      <span class="text-nowrap"> {{ data.item.payment_method.name }} </span>
    </template>
    </BTable>

    <div class="mx-2 mb-2">
          <BRow>

            <BCol cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start" >
              <span class="text-muted">{{ $t('Showing') }} {{ dataMeta.from }} {{ $t('to') }} {{ dataMeta.to }} {{ $t('of') }} {{ dataMeta.of }} {{ $t('entries') }}</span>
            </BCol>
            <!-- Pagination -->
            <BCol cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">

              <BPagination v-model="currentPage" :total-rows="totalExpenses" :per-page="perPage" first-number last-number class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item" >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </BPagination>

            </BCol>

          </BRow>
        </div>
  </BCard>
</template>
<script>
  import { BTab, BTabs, BCard, BAlert, BLink, BAvatar, BTable, BCol, BRow, BPagination } from 'bootstrap-vue'
  import { ref, inject} from '@vue/composition-api'
  import store from '@/store'
  import AccountsViewTabGeneral from './AccountsViewTabGeneral'
  import AccountsViewTabBilling from './AccountsViewTabBilling'
  import popups from '@/hooks/popups'
  import ability from '@/libs/acl/ability'
  import axios from '@axios'
  import router from '@/router'
  import { getInvoices } from '@/composables/invoiceService'
  import useExpensesList from '../../expenses/expenses-list/useExpensesList'
  import currency from '@/utils/currency'
  import dateUtils from '@/hooks/dateUtils' 

  export default {
    components: { BTab, BTabs, BCard, BAlert, BLink, AccountsViewTabGeneral, AccountsViewTabBilling, BAvatar, BTable, BCol, BRow, BPagination}, 
    setup() {

        const account = inject('account')
        const { fetchExpenses, isPartialPaid, perPage, currentPage, totalExpenses, dataMeta, perPageOptions, searchQuery, sortBy, isSortDirDesc, refExpenseListTable, accountFilter,  refetchData, resolveExpenseStatusVariantAndIcon, resolveClientAvatarVariant } = useExpensesList()
        const { formatCurrency } = currency()
        const { formatDate } = dateUtils()

        accountFilter.value=account.value.id
        const tableColumns = [
          { key: 'id', label: '#', sortable: true },
          { key: 'amount', label: 'Importe', sortable: true },
          { key: 'dates', label: 'Fechas', sortable: true },
          { key: 'payment_method', label: 'Método de pago', sortable: true },
          { key: 'paid', label: 'Pagado', sortable: true },
        ]



        return {
          account,
          perPageOptions, 
          searchQuery,
          sortBy,
          isSortDirDesc, 
          refExpenseListTable,
          fetchExpenses,
          tableColumns,
          formatCurrency,
          isPartialPaid,
          formatDate,
          resolveExpenseStatusVariantAndIcon,
          dataMeta,
          totalExpenses,
          perPage,
          currentPage
        }
    },
  }
  </script>